import { useAuthInvitationValidate } from "@boundless/bl-api-client/auth/services"
import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { LoaderCircleIcon } from "lucide-react"
import { z } from "zod"

import { InvitationForm } from "@/components/account/InvitationForm"

export const Route = createFileRoute("/(public)/_account/invitation")({
  component: RouteComponent,
  validateSearch: z.object({
    token: z.string().catch(""),
  }),
  beforeLoad: ({ search: { token } }) => {
    if (!token) {
      throw redirect({ to: "/" })
    }
  },
  wrapInSuspense: false,
})

function RouteComponent() {
  const { token } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  const {
    data: invitation,
    isPending,
    isError,
  } = useAuthInvitationValidate(token)

  if (isPending) {
    return <LoaderCircleIcon className="text-primary h-10 w-10 animate-spin" />
  } else if (isError) {
    return (
      <p className="text-center">
        The invitation link is invalid, possibly because it has already been
        used. Please contact our support team at{" "}
        <a
          className="text-primary"
          href={`mailto:${boundlessConfig.supportEmail}`}
        >
          {boundlessConfig.supportEmail}
        </a>
        .
      </p>
    )
  }

  return (
    <InvitationForm
      invitation={invitation}
      onSuccess={() => navigate({ to: "/" })}
    />
  )
}
